import { ComponentPropsWithRef, ElementType, ReactNode } from "react";
import cx from "classnames";
import styles from "./content.module.scss";

type TProps<T extends ElementType> = {
  as?: T;
  children: ReactNode;
  isWithFooter?: boolean;
} & ComponentPropsWithRef<T>;

export default function Content<T extends ElementType = "div">({
  as,
  children,
  isWithFooter = false,
  className,
  ...props
}: TProps<T>) {
  const Element = as || "div";

  return (
    <Element {...props} className={cx(styles.wrapper, className, { [styles.with]: isWithFooter })}>
      {children}
    </Element>
  );
}
